<template>
<b-card>
  <b-form-checkbox-group style="column-count: 2;" stacked id="creditCards" name="creditCards" v-model="creditCards" class="cc-wrapper" @change="onChange">
    <b-form-checkbox value="American Express" :disabled="this.disabled"><font-awesome-icon :icon="[ 'fab', 'cc-amex' ]" size="3x"/> American Express</b-form-checkbox>
    <b-form-checkbox value="Discover" :disabled="this.disabled"><font-awesome-icon :icon="[ 'fab', 'cc-discover' ]" size="3x" /> Discover</b-form-checkbox>
    <b-form-checkbox value="MasterCard" :disabled="this.disabled"><font-awesome-icon :icon="[ 'fab', 'cc-mastercard' ]" size="3x" /> MasterCard</b-form-checkbox>
    <b-form-checkbox value="Visa" :disabled="this.disabled"><font-awesome-icon :icon="[ 'fab', 'cc-visa' ]" size="3x" /> Visa</b-form-checkbox>
    <b-form-checkbox value="Apple Pay" :disabled="this.disabled"><font-awesome-icon :icon="[ 'fab', 'cc-apple-pay' ]" size="3x" /> Apple Pay</b-form-checkbox>
    <b-form-checkbox value="Google Pay" :disabled="this.disabled"><font-awesome-icon :icon="[ 'fab', 'google' ]" size="3x" /> Google Pay</b-form-checkbox>
  </b-form-checkbox-group>
</b-card>
</template>

<script>
export default {
  data() {
    return {
      creditCards: [],
    };
  },
  props: {
    value: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.creditCards = this.value;
    },
  },
  mounted() {
    this.creditCards = this.value;
  },
  methods: {
    onChange() {
      this.$nextTick(() => {
        this.$emit('input', this.creditCards);
        this.$emit('change', this.creditCards);
      });
    },
  },
};
</script>

<style scoped>

</style>
